// import Home   from "./pages/Home.svelte";
// import About  from "./pages/About.svelte";
// import Add    from "./pages/Add.svelte";
// import Drops    from "./pages/Drops.svelte";
// import Drop    from "./pages/Drop.svelte";
//
// import Claimable    from "./pages/Claimable.svelte";
// import RecentClaims    from "./pages/RecentClaims.svelte";

import NotFound    from "./pages/NotFound.svelte";

import MainWindow from "./pages/MainWindow.svelte";


import Layout from "./pages/Layout.svelte";


const routes = [
    {
        name: '404',
        path: '404',
        component: NotFound
    },

    // {
    //     name: '/drops',
    //     component: MainWindow,
    //     layout:Layout,
    //
    // },
    // {
    //     name: '/drop/:secondParam/:thirdParam',
    //     component: MainWindow,
    //     layout:Layout,
    //
    // },
    // {
    //     name: '/about',
    //     component: MainWindow,
    //     layout:Layout,
    //
    // },
    // {
    //     name: '/claimable',
    //     component: MainWindow,
    //     layout:Layout,
    //
    // },
    // {
    //     name: '/past',
    //     component: MainWindow,
    //     layout:Layout,
    //
    // },
    // {
    //     name: '/add',
    //     component: MainWindow,
    //     layout:Layout,
    //
    // },
    {
        name: '/:firstParam/:secondParam/:thirdParam',
        component: MainWindow,
        layout:Layout,

    },
    // {
    //     name: '/',
    //     component: MainWindow,
    //     layout:Layout,
    //
    // },


    // {
    //     name: '/:firstParam/:secondParam',
    //     component: MainWindow,
    //     layout:Layout,
    // },
    // {
    //     name: '/:firstParam',
    //     component: MainWindow,
    //     layout:Layout,
    // },
    // {
    //     name: '/',
    //     component: MainWindow,
    //     layout:Layout,
    // },


    // {
    //     name: 'home',
    //     component: Home,
    //     layout:Layout,
    // },
    //
    // {
    //     name: 'about',
    //     component: About,
    //     layout:Layout,
    // },
    // {
    //     name: 'add',
    //     component: Add,
    //     layout:Layout,
    // },
    // {
    //     name: 'drops',
    //     component: Drops,
    //     layout:Layout,
    // },
    // {
    //     name: 'drop/:dropTokenAddress/:dropTokenId',
    //     component: Drop,
    //     layout:Layout,
    // },
    // {
    //     name: 'claimable',
    //     component: Claimable,
    //     layout:Layout,
    // },
    // {
    //     name: 'recent',
    //     component: RecentClaims,
    //     layout:Layout,
    // },
]




export { routes }